import React from 'react';
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const features = [
    {
      icon: function Brain({ ...props }) {
        return (
          <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" />
            <path d="M14.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" />
            <path d="M3 7.5c0-1.667 1.333-3 3-3" />
            <path d="M18 4.5c1.667 0 3 1.333 3 3" />
            <path d="M21 18.5c0 1.667-1.333 3-3 3" />
            <path d="M3 18.5c0 1.667 1.333 3 3 3" />
            <path d="M12 12a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" />
            <path d="M12 17v2.5" />
            <path d="M8.5 14.5c-1.667 0-3-1.333-3-3v-2c0-1.667 1.333-3 3-3h7c1.667 0 3 1.333 3 3v2c0 1.667-1.333 3-3 3" />
          </svg>
        );
      },
      title: "Inteligencia Artificial Avanzada",
      description: "Utilizamos las últimas tecnologías en IA para crear soluciones innovadoras",
    },
    {
      icon: function Laptop({ ...props }) {
        return (
          <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16" />
          </svg>
        );
      },
      title: "Soluciones Personalizadas",
      description: "Desarrollamos soluciones adaptadas a las necesidades específicas de tu empresa",
    },
    {
      icon: function Users({ ...props }) {
        return (
          <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        );
      },
      title: "Equipo Experto",
      description: "Contamos con profesionales altamente cualificados en IA y desarrollo",
    },
  ];

const Home = () => {
    return (
        <div className="animate-fadeIn">
        {/* Hero Section */}
        <section className="relative h-[90vh] flex items-center justify-center bg-gradient-to-b from-gray-50 to-white overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-aulanovus-blue/10 to-aulanovus-green/10 animate-[pulse_4s_ease-in-out_infinite]" />
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="font-poppins font-bold text-4xl md:text-6xl lg:text-7xl text-gray-900 mb-6">
              Transformando el lugar de trabajo con{" "}
              <span className="text-aulanovus-blue">inteligencia artificial</span>
            </h1>
            <p className="font-inter text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Soluciones avanzadas de IA para potenciar la eficiencia y productividad de tu empresa
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/servicios"
                className="inline-flex items-center px-6 py-3 font-inter font-medium text-white bg-aulanovus-blue rounded-lg transition-all hover:bg-aulanovus-blue/90 hover:scale-105"
              >
                Explorar servicios
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              <Link
                to="/contacto"
                className="inline-flex items-center px-6 py-3 font-inter font-medium text-aulanovus-blue bg-blue-50 rounded-lg transition-all hover:bg-blue-100"
              >
                Contactar
              </Link>
            </div>
          </div>
        </section>
  
        {/* Features Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="font-poppins font-bold text-3xl md:text-4xl text-gray-900 mb-4">
                ¿Por qué elegir Aulanovus?
              </h2>
              <p className="font-inter text-gray-600 max-w-2xl mx-auto">
                Combinamos experiencia técnica con un profundo entendimiento de las necesidades empresariales
              </p>
            </div>
  
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
                >
                  <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4">
                    <feature.icon className="w-6 h-6 text-aulanovus-blue" />
                  </div>
                  <h3 className="font-poppins font-semibold text-xl text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="font-inter text-gray-600">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
  
        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-aulanovus-blue to-aulanovus-green">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-poppins font-bold text-3xl md:text-4xl text-white mb-6">
              ¿Listo para transformar tu negocio?
            </h2>
            <p className="font-inter text-white/90 mb-8 max-w-2xl mx-auto">
              Descubre cómo nuestras soluciones de IA pueden impulsar tu empresa hacia el futuro
            </p>
            <Link
              to="/contacto"
              className="inline-flex items-center px-6 py-3 font-inter font-medium text-aulanovus-blue bg-white rounded-lg transition-all hover:bg-gray-50 hover:scale-105"
            >
              Comenzar ahora
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>
        </section>
      </div>
    );
};

export default Home;